import i18nInstance from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import merge from "lodash/merge";

export const i18n = i18nInstance.createInstance();
export const defaultNS = "translation";

export const flattenResources = (resources: Record<string, any>, prefix = ""): Record<string, string> => {
  return Object.keys(resources).reduce<Record<string, string>>((acc, key) => {
    if (typeof resources[key] === "string") {
      acc[`${prefix}${key}`] = resources[key];
    } else {
      acc = { ...acc, ...flattenResources(resources[key], `${prefix}${key}.`) };
    }
    return acc;
  }, {});
};

// Deep merge before flattening so bundles sharing a namespace merge key by key instead of the last
// one replacing the whole sub-tree.
export const mergeResources = (...bundles: Record<string, any>[]): Record<string, string> => flattenResources(merge({}, ...bundles));

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    detection: {
      order: ["sessionStorage", "navigator"],
      caches: [],
    },
    resources: {},
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
    },
  });

i18n.addResources("en", defaultNS, {
  no_results: "No results",
  text_copied_successfully: "Text copied to clipboard successfully",
  settings_refresh_user: "Refresh my User",
  need_help_getting_started: "Need help getting started? See our",
  docs: "docs",
  yes: "Yes",
  ok: "OK",
  done: "Done",
  actions_cancel: "Cancel",
  whatslly_dynamic_templates: "Dynamic Templates",
  field_is_required: "Field is required",
  invalid_date: "Invalid date",
  invalid_url: "Invalid url",
  helpers_no_results: "No Results",
  ORG_ID_PREFIX: "OrgId: ",
  USER_ID_PREFIX: "UserId: ",
  VERSION_PREFIX: "Version: ",
  salesforce_no_api: "We could not connect to your salesforece account because your api is disable to enable your salesforce api follow",
  salesforce_no_api_link: "this guide",
  confirm_change_language: "Are you sure you want to change the language to {{language}}?",
  revoke: "Revoke",
  disconnect: "Disconnect",
  "language.en": "English",
  "language.es": "Spanish",
  "language.pt": "Portuguese",
  search: "Search",
  "table_multiple_items_action.selected": "selected",
  "table_multiple_items_action.deselect_all": "Deselect all",
  "table_multiple_items_action.actions_available": "Actions available",
  disappearing_message_default: "Disappearing Message",
  disappearing_message_image: "Disappearing Image",
  disappearing_message_video: "Disappearing Video",
  disappearing_message_audio: "Disappearing Audio",
});
i18n.addResources("es", defaultNS, {
  no_results: "Sin resultados",
  text_copied_successfully: "Texto copiado al portapapeles exitosamente",
  settings_refresh_user: "Actualizar mi usuario",
  need_help_getting_started: "¿Necesitas ayuda para comenzar? Checa nuestro",
  docs: "documentos",
  yes: "Sí",
  ok: "OK",
  done: "Listo",
  actions_cancel: "Cancelar",
  whatslly_dynamic_templates: "Plantillas Dinámicas",
  field_is_required: "Se requiere campo",
  invalid_date: "Fecha invalida",
  invalid_url: "URL invalida",
  helpers_no_results: "No Hay Resultados",
  ORG_ID_PREFIX: "OrgId: ",
  USER_ID_PREFIX: "UserId: ",
  VERSION_PREFIX: "Version: ",
  salesforce_no_api: "No pudimos conectarnos a tu cuenta de Salesforce porque tu API está deshabilitada. Para habilitar tu API de Salesforce, sigue",
  salesforce_no_api_link: "esta guía",
  confirm_change_language: "¿Estás seguro de que deseas cambiar el idioma a {{language}}?",
  revoke: "Revocar",
  disconnect: "Desconectar",
  "language.en": "Inglés",
  "language.es": "Español",
  "language.pt": "Portugués",
  search: "Buscar",
  "table_multiple_items_action.selected": "seleccionados",
  "table_multiple_items_action.deselect_all": "Deseleccionar todo",
  "table_multiple_items_action.actions_available": "Acciones disponibles",
  disappearing_message_default: "Mensajes Temporales",
  disappearing_message_image: "Imagen Temporal",
  disappearing_message_video: "Video Temporal",
  disappearing_message_audio: "Audio Temporal",
});
i18n.addResources("pt", defaultNS, {
  no_results: "Sem resultados",
  text_copied_successfully: "Texto copiado para a área de transferência com sucesso",
  settings_refresh_user: "Atualizar meu usuário",
  need_help_getting_started: "Precisa de ajuda para começar? Veja nosso",
  docs: "documentos",
  yes: "Sim",
  ok: "OK",
  done: "Feito",
  actions_cancel: "Cancelar",
  whatslly_dynamic_templates: "Modelos Dinâmicos",
  field_is_required: "Campo é obrigatório",
  invalid_date: "Data inválida",
  invalid_url: "URL inválida",
  helpers_no_results: "Sem Resultados",
  ORG_ID_PREFIX: "OrgId: ",
  USER_ID_PREFIX: "UserId: ",
  VERSION_PREFIX: "Version: ",
  salesforce_no_api: "Não conseguimos conectar à sua conta do Salesforce porque a sua API está desativada. Para ativar a sua API do Salesforce, siga",
  salesforce_no_api_link: "este guia",
  confirm_change_language: "Tem certeza de que deseja mudar o idioma para {{language}}?",
  revoke: "Revogar",
  disconnect: "Desconectar",
  "language.en": "Inglês",
  "language.es": "Espanhol",
  "language.pt": "Português",
  search: "Pesquisar",
  "table_multiple_items_action.selected": "selecionados",
  "table_multiple_items_action.deselect_all": "Desmarcar todos",
  "table_multiple_items_action.actions_available": "Ações disponíveis",
  disappearing_message_default: "Mensagens Temporárias",
  disappearing_message_image: "Imagem Temporal",
  disappearing_message_video: "Vídeo Temporal",
  disappearing_message_audio: "Áudio Temporal",
});
